import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { useWeb3Auth } from '../auth/Web3AuthContext';
import { RootState } from '../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn, isInitialized, isRestoringSession } = useWeb3Auth();
  // Persisted login state survives a full out-of-scope round trip (e.g. the PWA
  // navigating to Guardarian's hosted checkout and back), whereas the live
  // Web3Auth provider does not. Gate the shell on the persisted flag so the user
  // stays in the app while the provider rehydrates in the background; logout
  // clears this via setAuthenticated(false) + PURGE, so it can't admit a
  // genuinely signed-out user.
  const isAuthenticated = useSelector((state: RootState) => state.authSlice.isAuthenticated);
  const location = useLocation();

  if (!isInitialized || isRestoringSession) {
    return null;
  }

  if (!isLoggedIn && !isAuthenticated) {
    // Redirect to the signin page if not logged in
    return <Navigate to="/SignIn" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};